import { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";

export const useSucursales = () => {
  const [sucursales, setSucursales] = useState(["CDMX", "Querétaro", "Guadalajara", "Claveria", "Monterrey"]);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(collection(db, "sucursales"));
        if (!snap.empty) {
          const names = snap.docs.map(d => d.data()?.nombre).filter(Boolean);
          if (names.length) setSucursales(names);
        }
      } catch {
        /* fallback con las por defecto */
      }
    })();
  }, []);

  return sucursales;
};